export function getSeededNumberInRange(seed: string | number, min: number, max: number): number {
  const numericSeed = typeof seed === 'number'
    ? seed
    : seed.split('').reduce((accumulator, character) => {
      return ((accumulator << 5) - accumulator) + character.charCodeAt(0)
    }, 0)
  const hashed = Math.sin(numericSeed * 12.9898) * 43758.5453
  const unit = hashed - Math.floor(hashed)
  return min + unit * (max - min)
}
